/**
 * The slot registrations of `web/ledger` (1.M-2 deliverable 14): the play and discovery pill
 * (`header.pills.play-discovery`, order 30). `apps/web/src/editor-services/slots.ts` collects them
 * as `SLOT_MODULES['web/ledger']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { lazy } from 'react';

/** Loaded on first use, as 1.I-3's pills are: the pills row renders it inside a `Suspense`. */
const PlayDiscoveryPill = lazy(() =>
  import('./play-discovery-pill.js').then((module) => ({ default: module.PlayDiscoveryPill })),
);

export const owner: WorkPackageId = '1.M-2';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'header.pills', order: 30, owner: '1.M-2', component: PlayDiscoveryPill },
];
